module.exports = __webpack_public_path__ + "img/coinbankB06.7052eded.jpg";